import MetricsGallery from './MetricsGallery';

export default MetricsGallery;
